// extracted by mini-css-extract-plugin
module.exports = {"main":"index_main__X1Shi"};